import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RackDashboard } from './rack.dsbd';

export class StockResponseData extends GlobalResponseObject {
    data?: RackDashboard[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, errorCode:number, internalMessage:string, data?: RackDashboard[]){
        super(status,errorCode,internalMessage);
        this.data = data;
    }
}